import { useState } from 'react';

const MintPage = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [mintCount, setMintCount] = useState(0);

  const handleConnect = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
        setIsConnected(true);
      } catch (error) {
        console.error('User denied account access');
      }
    } else {
      alert('Please install MetaMask!');
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url(/def.png)',
          backgroundSize: 'cover'
        }}
      />
      
      {/* Top Light Effects */}
      <div className="absolute top-0 w-full">
        <div className="h-[2px] w-[30%] absolute left-0 bg-cyan-500/50 animate-slide-right" />
        <div className="h-[2px] w-[20%] absolute left-[35%] bg-blue-500/50 animate-slide-right-delay-1" />
        <div className="h-[2px] w-[40%] absolute right-0 bg-cyan-500/50 animate-slide-left" />
        <div className="h-[1px] w-full absolute bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent animate-pulse" />
      </div>

      {/* Bottom Light Effects */}
      <div className="absolute bottom-0 w-full">
        <div className="h-[2px] w-[35%] absolute right-0 bg-cyan-500/50 animate-slide-left" />
        <div className="h-[2px] w-[25%] absolute right-[40%] bg-blue-500/50 animate-slide-left-delay-1" />
        <div className="h-[2px] w-[30%] absolute left-0 bg-cyan-500/50 animate-slide-right" />
        <div className="h-[1px] w-full absolute bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent animate-pulse" />
      </div>

      {/* Main Content */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 bg-black/40">
        {/* Title */}
        <h1 className="text-6xl md:text-8xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 animate-pulse-slow relative">
          ELYSIA
          <div className="absolute -inset-2 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-xl animate-pulse-slow" />
        </h1>
        
        <div className="text-center mb-12">
          <p className="text-3xl md:text-4xl font-bold text-cyan-300">777 SUPPLY</p>
          <p className="text-xl text-cyan-400/80 mt-2">FREE MINT</p>
        </div>

        {/* Mint Card */}
        <div className="w-full max-w-md backdrop-blur-xl bg-black/40 rounded-3xl p-8 border border-cyan-500/30 
          shadow-[0_0_15px_rgba(34,211,238,0.1)] hover:shadow-[0_0_30px_rgba(34,211,238,0.2)] transition-all duration-500">
          
          {/* Mint Stats */}
          <div className="grid grid-cols-3 gap-6 mb-8">
            <div className="text-center p-3 rounded-xl hover:bg-cyan-500/5 transition-colors">
              <p className="text-cyan-300/80">Supply</p>
              <p className="text-2xl font-bold text-cyan-400">777</p>
            </div>
            <div className="text-center p-3 rounded-xl hover:bg-cyan-500/5 transition-colors">
              <p className="text-cyan-300/80">Minted</p>
              <p className="text-2xl font-bold text-cyan-400">{mintCount}/777</p>
            </div>
            <div className="text-center p-3 rounded-xl hover:bg-cyan-500/5 transition-colors">
              <p className="text-cyan-300/80">Price</p>
              <p className="text-2xl font-bold text-cyan-400">FREE</p>
            </div>
          </div>

          {/* Mint Button */}
          <button
            onClick={handleConnect}
            className="group relative w-full py-4 rounded-2xl overflow-hidden shadow-lg hover:shadow-cyan-500/50
              before:absolute before:inset-0 before:bg-gradient-to-r before:from-cyan-500 before:to-blue-500
              after:absolute after:inset-0 after:bg-gradient-to-r after:from-cyan-600 after:to-blue-600
              after:opacity-0 hover:after:opacity-100 after:transition-opacity after:duration-300"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/25 to-transparent 
              translate-x-[-200%] group-hover:translate-x-[200%] transition-all duration-700" />
            <span className="relative z-10 font-bold text-lg text-white">
              {isConnected ? "MINT NOW" : "CONNECT WALLET"}
            </span>
          </button>

          <p className="text-center mt-6 text-cyan-300/80">Mint Date: TBA</p>
        </div>

        {/* Social Links */}
        <div className="mt-12 flex gap-6">
          <a
            href="https://x.com/elysia_story"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative px-8 py-3 rounded-xl bg-cyan-500/10 overflow-hidden 
              shadow-lg hover:shadow-cyan-500/30 transition-all duration-300"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
              translate-x-[-200%] group-hover:translate-x-[200%] transition-all duration-700" />
            <span className="relative z-10">Twitter</span>
          </a>
          <a
            href="https://x.com/StoryProtocol"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative px-8 py-3 rounded-xl bg-cyan-500/10 overflow-hidden 
              shadow-lg hover:shadow-cyan-500/30 transition-all duration-300"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
              translate-x-[-200%] group-hover:translate-x-[200%] transition-all duration-700" />
            <span className="relative z-10">Story Protocol</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MintPage;